import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core'
import { Action } from '@ngrx/store'
import { Message } from 'primeng/api'
import { takeUntil, tap } from 'rxjs/operators'
import { isToastData } from '../toast-data.model'
import { MessageService } from '../../toast-module/messageservice'

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent implements OnInit, OnDestroy {
  @Output() buttonClick = new EventEmitter<Action>()
  @Output() dismiss = new EventEmitter<Action>()

  private readonly onDestroy = new EventEmitter<void>()

  constructor(
    private readonly messageService: MessageService,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.messageService.messageObserver
      .pipe(
        takeUntil(this.onDestroy),
        tap(() => {
          this.changeDetectorRef.markForCheck()
        }),
      )
      .subscribe()
  }

  public onClose(message: Message) {
    if (isToastData(message.data) && message.data.dismissAction) {
      this.dismiss.emit(message.data.dismissAction)
    }
  }

  public onToastButtonClick(event: Event, action: Action) {
    event.preventDefault()
    this.buttonClick.emit(action)
  }

  public isToastData(data: unknown) {
    return isToastData(data)
  }

  public ngOnDestroy(): void {
    this.onDestroy.emit()
  }
}
